var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMediaIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.80039 3.60156C4.16387 3.60156 3.55342 3.85442 3.10333 4.30451C2.65325 4.75459 2.40039 5.36504 2.40039 6.00156V18.0016C2.40039 18.6381 2.65325 19.2485 3.10333 19.6986C3.55342 20.1487 4.16387 20.4016 4.80039 20.4016H19.2004C19.8369 20.4016 20.4474 20.1487 20.8974 19.6986C21.3475 19.2485 21.6004 18.6381 21.6004 18.0016V6.00156C21.6004 5.36504 21.3475 4.75459 20.8974 4.30451C20.4474 3.85442 19.8369 3.60156 19.2004 3.60156H4.80039ZM19.2004 18.0016H4.80039L9.60039 8.40156L13.2004 15.6016L15.6004 10.8016L19.2004 18.0016Z",
    fill: "#032250"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaIcon);
export default __webpack_public_path__ + "static/media/media_icon.63099750f63bc73ba19ff434798e1dba.svg";
export { ForwardRef as ReactComponent };